import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import { ButtonGroup, Button, ControlLabel, FormGroup, HelpBlock, Input, Alert } from "components/bootstrap";
import { TIME_BASED_SIZE_OPTIMIZING_ROTATION_STRATEGY } from "hooks/useIndices";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { ARCHIVE_LICENSE_WARNING_TITLE, ARCHIVE_LICENSE_WARNING_TEXT } from "archive/constants";
const StyledAlert = styled(Alert)`
  overflow: auto;
`;
const ArchiveRetentionStrategyConfiguration = ({
  config,
  jsonSchema = void 0,
  updateConfig,
  useMaxNumberOfIndices
}) => {
  var _a;
  const [maxNumberOfIndices, setMaxNumberOfIndices] = useMaxNumberOfIndices();
  const [configuration, setConfiguration] = useState(config);
  const {
    values: { rotation_strategy_class: rotationStrategyClass }
  } = useFormikContext();
  const onMaxIndicesUpdate = (e) => {
    const { value } = e.target;
    const update = configuration;
    update.max_number_of_indices = value;
    setMaxNumberOfIndices(value);
    setConfiguration(update);
    updateConfig(update);
  };
  const setIndexAction = (type) => () => {
    setConfiguration({ ...configuration, index_action: type });
    updateConfig({ ...configuration, index_action: type });
  };
  const indexActionActive = (type) => {
    const { index_action } = configuration;
    return index_action === type;
  };
  const hasValidSchema = () => !!jsonSchema;
  const indexActions = () => {
    if (hasValidSchema()) {
      const newIndexActions = jsonSchema.properties.index_action.enum;
      newIndexActions.sort((a, b) => naturalSort(a.toLowerCase(), b.toLowerCase()));
      return newIndexActions;
    }
    return [];
  };
  const buttons = (_a = indexActions()) == null ? void 0 : _a.map((action) => {
    const isActive = indexActionActive(action);
    return /* @__PURE__ */ React.createElement(
      Button,
      {
        key: `button-${action}`,
        bsSize: "small",
        onClick: setIndexAction(action),
        active: isActive,
        bsStyle: isActive ? "info" : "default"
      },
      action
    );
  });
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: ARCHIVE_LICENSE_WARNING_TEXT,
      title: ARCHIVE_LICENSE_WARNING_TITLE,
      bsStyle: "danger",
      licenseSubject: LICENSE_SUBJECTS.archive
    }
  ), /* @__PURE__ */ React.createElement(StyledAlert, null, "The archive index retention strategy creates an archive for an index before deleting or closing it."), rotationStrategyClass !== TIME_BASED_SIZE_OPTIMIZING_ROTATION_STRATEGY && /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "max-number-of-indices",
      label: "Max number of indices",
      onChange: onMaxIndicesUpdate,
      value: maxNumberOfIndices,
      min: 1,
      help: /* @__PURE__ */ React.createElement("span", null, "Maximum number of indices to keep before ", /* @__PURE__ */ React.createElement("strong", null, "archiving"), " the oldest ones"),
      autoFocus: true,
      required: true
    }
  )), hasValidSchema() && /* @__PURE__ */ React.createElement(FormGroup, { id: "action-after-archive" }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Action after archiving index"), /* @__PURE__ */ React.createElement(ButtonGroup, null, buttons), /* @__PURE__ */ React.createElement(HelpBlock, null, "Please select which action should be performed once an index has been archived.")));
};
export default ArchiveRetentionStrategyConfiguration;
